import React from 'react';
import { Grid, Box, IconButton, Typography, Button } from '@mui/material';
import { Close } from '@material-ui/icons';
import CallIcon from "@mui/icons-material/Call";
import CallEndIcon from "@mui/icons-material/CallEnd";
import BarChartIcon from '@mui/icons-material/BarChart';
import MapaDoLocal from '../../Dashboard/mapaLocal.js';
import ModuloPGMComponent from '../ModuloPGMComponent/index';
import ModuloSonoroComponent from '../ModuloSonoroComponent/index';
import CornetaComponent from '../CornetaComponent/index';
import CentralComponent from '../CentralComponent/index';
import ModuloGatewayComponent from '../ModuloGatewayComponent/index';
import ModuloSentinelComponent from '../ModuloSentinelComponent/index';
import CamerasComponent from '../CamerasComponent/index';

const PainelInstalacaoDetalhes = ({
    instalacaoSelecionada,
    setInstalacaoSelecionada,
    larguraOriginal,
    limiar,
    darkMode,
    activeCallRamal,
    handleSipHangup,
    handleSipCall,
    returnDescricaoEndereco,
    handleOpenGraficoDisponibilidade,
    useNativeCall,
    toggleSipMode,
    sipStatus,
    handleOpenMosaicoDisponibilidade,
    handleOpenMosaico,
    openMosaico,
    closeMosaico,
    cameras,
    urlStream,
    openMosaicoDisponibilidade,
    closeMosaicoDisponibilidade
}) => {
    return (
        <>
                                    {instalacaoSelecionada && (
                                <div className={larguraOriginal < limiar ? "fullPageMobileContainer" : "fullPageContainer"}
                                    style={{
                                        backgroundColor: darkMode ? '#121212' : 'white',
                                        color: darkMode ? '#fff' : 'black',
                                        transition: '0.3s ease',
                                        top: '10px',
                                        
                                        zIndex: 10000 // Garantindo que fique acima da barra de navegação
                                    }}
                                >
                                    <Grid
                                        container
                                        justifyContent="center"
                                        align="center"
                                        item xs={12}


                                    >

                                        <Box 
                                            sx={{
                                                position: 'sticky',
                                                top: '-16px', // Compensa o padding do contêiner
                                                px: 2,
                                                py: 1.5,
                                                width: '100%',
                                                zIndex: 1210, // Fica acima de tudo no painel
                                                backgroundColor: darkMode ? '#121212' : '#ffffff',
                                                borderBottom: `2px solid ${darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}`,
                                                boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 2,
                                                mb: 2
                                            }}
                                        >
                                            <IconButton
                                                onClick={() => setInstalacaoSelecionada(null)}
                                                sx={{
                                                    backgroundColor: '#FF4500',
                                                    color: 'white',
                                                    '&:hover': { backgroundColor: '#D32F2F', transform: 'scale(1.1)' },
                                                    boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                                                    transition: 'all 0.2s ease-in-out',
                                                    flexShrink: 0
                                                }}
                                            >
                                                <Close />
                                            </IconButton>
                                            <Typography sx={{ fontSize: '1.2rem', fontWeight: 800, color: darkMode ? '#fff' : '#000', letterSpacing: '0.5px' }} noWrap>
                                                {instalacaoSelecionada.tipo_instalacao === 0 ? (instalacaoSelecionada.nome + " " + instalacaoSelecionada.sobrenome) : instalacaoSelecionada.nome_fantasia} - {instalacaoSelecionada.tipo_instalacao === 0 ? instalacaoSelecionada.cpf : instalacaoSelecionada.cnpj} - {instalacaoSelecionada.identificador_integrador}
                                            </Typography>

                                            {(() => {
                                                const status_central = instalacaoSelecionada.status_central;
                                                const now = new Date();
                                                const lastResponse = new Date(instalacaoSelecionada.data_hora_ultima_resposta);
                                                const differenceInMinutes = (now - lastResponse) / 1000 / 60;
                                        
                                                let statusText, statusColor;
                                        
                                                if (status_central === 2) {
                                                    statusText = "ALARME CRÍTICO";
                                                    statusColor = "#ef4444";
                                                } else if (differenceInMinutes < 3) {
                                                    if (status_central === 1) {
                                                        statusText = "SISTEMA PROTEGIDO";
                                                        statusColor = "#10b981";
                                                    } else {
                                                        statusText = "SISTEMA DESARMADO";
                                                        statusColor = "#f59e0b";
                                                    }
                                                } else {
                                                    statusText = "SISTEMA OFFLINE";
                                                    statusColor = "#8b5cf6";
                                                }
                                        
                                                const ramais = instalacaoSelecionada.equipamentos
                                                    ? Array.from(new Set(instalacaoSelecionada.equipamentos.map(e => e.ramal).filter(r => r && r.toString().trim() !== '')))
                                                    : [];
                                        
                                                return (
                                                    <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: 2 }}>
                                                        {ramais.map(ramal => (
                                                            <Button
                                                                key={ramal}
                                                                variant="contained"
                                                                size="small"
                                                                sx={{ 
                                                                    backgroundColor: activeCallRamal === ramal ? '#ef4444' : '#48D1CC', 
                                                                    color: 'white',
                                                                    fontWeight: 'bold',
                                                                    borderRadius: '20px',
                                                                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                                                                    textTransform: 'none',
                                                                    padding: '4px 12px',
                                                                    '&:hover': {
                                                                        backgroundColor: activeCallRamal === ramal ? '#dc2626' : '#3db8b5'
                                                                    }
                                                                }}
                                                                startIcon={activeCallRamal === ramal ? <CallEndIcon /> : <CallIcon />}
                                                                onClick={() => {
                                                                    if (activeCallRamal === ramal) {
                                                                        handleSipHangup();
                                                                    } else {
                                                                        handleSipCall(ramal);
                                                                    }
                                                                }}
                                                            >
                                                                {activeCallRamal === ramal ? `Desligar (${ramal})` : `Ligar (${ramal})`}
                                                            </Button>
                                                        ))}
                                        
                                                        <Box sx={{ 
                                                            display: 'flex', alignItems: 'center', gap: 1, 
                                                            px: 2, py: 0.5, borderRadius: '20px', 
                                                            backgroundColor: `${statusColor}22`, 
                                                            border: `1px solid ${statusColor}`
                                                        }}>
                                                            <div style={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: statusColor, boxShadow: `0 0 8px ${statusColor}` }} />
                                                            <Typography sx={{ fontWeight: 800, fontSize: '0.85rem', color: statusColor, letterSpacing: '0.5px', whiteSpace: 'nowrap' }}>
                                                                {statusText}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                );
                                            })()}
                                        </Box>

                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="center"
                                            align="center"
                                            item xs={12}

                                        >
                                            <Grid
                                                container
                                                item xs={6}
                                                style={{}}
                                                direction="column"
                                            >
                                                <Grid
                                                    container
                                                    direction="row"
                                                    justifyContent="center"
                                                    align="center"
                                                    item xs={10}
                                                >
                                                    <span style={{ paddingTop: 10, paddingBottom: 1, fontSize: 16 }}>{returnDescricaoEndereco(instalacaoSelecionada)}</span>
                                                </Grid>
                                                <Grid
                                                    container
                                                    justifyContent="flex-start"
                                                    align="flex-end"
                                                    item xs={2}
                                                >
                                                    <button
                                                        onClick={() => handleOpenGraficoDisponibilidade()} // Função de fechar
                                                        style={{
                                                            backgroundColor: 'blue',
                                                            color: 'white',
                                                            border: 'none',
                                                            borderRadius: '8px',
                                                            padding: '4px 10px',
                                                            fontSize: '12px',
                                                            cursor: 'pointer',
                                                            fontWeight: 'bold',
                                                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                                            textTransform: 'uppercase',
                                                            display: 'flex',  // Garante que o ícone e o texto fiquem lado a lado
                                                            alignItems: 'center',  // Alinha verticalmente
                                                            gap: '5px'  // Espaço entre o ícone e o texto
                                                        }}
                                                    >
                                                        <BarChartIcon style={{ fontSize: '32px' }} />
                                                        Disponibilidade
                                                    </button>

                                                </Grid>
                                            </Grid>


                                            <Grid
                                                container
                                                justifyContent="center"
                                                align="center"
                                                item xs={6}
                                                style={{ minHeight: '300px', border: `1px solid ${darkMode ? '#fff' : 'black'}` }}


                                            > {
                                                    instalacaoSelecionada && (
                                                        <MapaDoLocal
                                                            instalacao={instalacaoSelecionada}
                                                            tipo_icone={instalacaoSelecionada.icone_mapa}
                                                            nome_mapa={instalacaoSelecionada.nome_mapa}
                                                        />
                                                    )
                                                }
                                            </Grid>
                                        </Grid>




                                        {instalacaoSelecionada.equipamentos
                                            .sort((a, b) => a.id_equipamento - b.id_equipamento)
                                            .map((equipamento) => {

                                                return (
                                                    equipamento && equipamento.tipo_equipamento_area_tecnica === 0 && equipamento.modulo_pgm && equipamento.modulo_pgm.id_modulo_pgm > 0 ? (
                                                        <ModuloPGMComponent
                                                            key={equipamento.id_equipamento}
                                                            tipo={equipamento.tipo_equipamento_area_tecnica}
                                                            equipamento={equipamento}
                                                            id_instalacao={instalacaoSelecionada.id_instalacao}
                                                            flag={1}
                                                        />
                                                    ) :
                                                        equipamento && equipamento.tipo_equipamento_area_tecnica === 70 ?
                                                            (
                                                                <CentralComponent
                                                                    key={equipamento.id_equipamento}
                                                                    tipo={equipamento.tipo_equipamento_area_tecnica}
                                                                    equipamento={equipamento}
                                                                    id_instalacao={instalacaoSelecionada.id_instalacao}
                                                                    id_sigma={instalacaoSelecionada.identificador_integrador}

                                                                    flag={1}
                                                                />
                                                            )
                                                            :
                                                            equipamento && (equipamento.tipo_equipamento_area_tecnica === 30 && equipamento.modulo_sonoro && equipamento.modulo_sonoro.id_modulo_sonoro > 0) ?
                                                                (
                                                                    <ModuloSonoroComponent
                                                                        key={equipamento.id_equipamento}
                                                                        tipo={equipamento.tipo_equipamento_area_tecnica}
                                                                        equipamento={equipamento}
                                                                        id_instalacao={instalacaoSelecionada.id_instalacao}
                                                                        id_sigma={instalacaoSelecionada.identificador_integrador}
                                                                        flag={1}
                                                                        useNativeCall={useNativeCall}
                                                                        setUseNativeCall={toggleSipMode}
                                                                        sipStatus={sipStatus}
                                                                        activeCallRamal={activeCallRamal}
                                                                        onSipCall={handleSipCall}
                                                                        onSipHangup={handleSipHangup}
                                                                    />
                                                                ) :
                                                                equipamento && equipamento.tipo_equipamento_area_tecnica === 120 ?
                                                                    (
                                                                        <CornetaComponent
                                                                            key={equipamento.id_equipamento}
                                                                            tipo={equipamento.tipo_equipamento_area_tecnica}
                                                                            equipamento={equipamento}
                                                                            id_instalacao={instalacaoSelecionada.id_instalacao}
                                                                            flag={1}
                                                                            id_sigma={instalacaoSelecionada.identificador_integrador}
                                                                            useNativeCall={useNativeCall}
                                                                            setUseNativeCall={toggleSipMode}
                                                                            sipStatus={sipStatus}
                                                                            activeCallRamal={activeCallRamal}
                                                                            onSipCall={handleSipCall}
                                                                            onSipHangup={handleSipHangup}
                                                                        />
                                                                    )
                                                                    : equipamento && equipamento.tipo_equipamento_area_tecnica === 5 ? (
                                                                        <ModuloGatewayComponent
                                                                            key={equipamento.id_equipamento}
                                                                            tipo={equipamento.tipo_equipamento_area_tecnica}
                                                                            equipamento={equipamento}
                                                                            id_instalacao={instalacaoSelecionada.id_instalacao}
                                                                            flag={1}
                                                                            instalacao={instalacaoSelecionada}
                                                                        />
                                                                    )
                                                                        : equipamento && equipamento.tipo_equipamento_area_tecnica === 8 ? (
                                                                            <ModuloSentinelComponent
                                                                                key={equipamento.id_equipamento}
                                                                                tipo={equipamento.tipo_equipamento_area_tecnica}
                                                                                equipamento={equipamento}
                                                                                id_instalacao={instalacaoSelecionada.id_instalacao}
                                                                                flag={1}
                                                                                instalacao={instalacaoSelecionada}
                                                                            />
                                                                        )
                                                                            : null


                                                );
                                            })}


                                        <button
                                            onClick={() => handleOpenMosaicoDisponibilidade()} // Função de fechar
                                            style={{
                                                backgroundColor: 'green', // Cor laranja-avermelhada estilosa (TOP!)
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '8px',
                                                padding: '2px 8px',
                                                fontSize: '12px',
                                                cursor: 'pointer',
                                                fontWeight: 'bold',
                                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', // Sombra leve
                                                textTransform: 'uppercase',
                                            }}
                                        >
                                            Mosaico via serviço de disponibilidade
                                        </button>


                                        <button
                                            onClick={() => handleOpenMosaico(instalacaoSelecionada.url_video_stream, instalacaoSelecionada.equipamentos)} // Função de fechar
                                            style={{
                                                backgroundColor: 'green', // Cor laranja-avermelhada estilosa (TOP!)
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '8px',
                                                padding: '2px 8px',
                                                fontSize: '12px',
                                                cursor: 'pointer',
                                                fontWeight: 'bold',
                                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', // Sombra leve
                                                textTransform: 'uppercase',
                                            }}
                                        >
                                            Mosaico via Unifier
                                        </button>



                                    </Grid>
                                </div>

                            )}







                            {/* Modal */}
                            {openMosaico && (
                                <div
                                    style={{
                                        position: "fixed",
                                        top: "0",
                                        left: "0",
                                        width: "100vw",
                                        height: "100vh",
                                        backgroundColor: "rgba(0, 0, 0, 0.5)", // Fundo escuro com opacidade
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        zIndex: "1100",
                                    }}
                                >
                                    <div
                                        style={{
                                            backgroundColor: darkMode ? "#1e1e1e" : "white",
                                            color: darkMode ? "#fff" : "inherit",
                                            width: "95%",
                                            height: "95%",
                                            borderRadius: "8px",
                                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)", // Sombra para destaque
                                            display: "flex",
                                            flexDirection: "column",
                                            padding: "10px",
                                            position: "relative",
                                        }}
                                    >
                                        {/* Botão de fechar */}
                                        <button
                                            onClick={(e) => closeMosaico()}
                                            style={{
                                                position: "absolute",
                                                top: "10px",
                                                right: "10px",
                                                backgroundColor: "#FF4500",
                                                color: "white",
                                                border: "none",
                                                borderRadius: "4px",
                                                padding: "8px",
                                                cursor: "pointer",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            Fechar
                                        </button>



                                        {/* Conteúdo do Modal */}
                                        <h6 style={{ marginTop: 0 }}>Mosaico</h6>

                                        {/* Espaço reservado para a tabela */}
                                        <div
                                            style={{
                                                flex: 1,
                                                overflowY: "auto", // Adiciona rolagem se a tabela for grande
                                                border: darkMode ? "1px solid #444" : "1px solid #ddd",
                                                borderRadius: "4px",
                                                padding: "10px",
                                                backgroundColor: darkMode ? "#121212" : "transparent"
                                            }}
                                        >

                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="center"
                                                align="center"
                                                item xs={12}
                                                style={{ padding: 1 }}
                                            >
                                                {cameras.map((equipamento, index) => {
                                                    if (equipamento.tipo_equipamento_area_tecnica === 80) {
                                                        return (
                                                            <Grid
                                                                item
                                                                xs={12}
                                                                sm={6}
                                                                md={6}
                                                                lg={6}
                                                                key={index}
                                                                style={{
                                                                    border: "1px solid red",
                                                                    padding: "1px",
                                                                    margin: "1px",
                                                                    borderRadius: "8px",
                                                                    height: "300px", // Define uma altura fixa (ou ajuste conforme necessário)
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    overflow: "hidden" // Evita margens extras
                                                                }}
                                                            >

                                                                <iframe
                                                                    src={`${urlStream}/${equipamento.rota_camera}`}
                                                                    style={{
                                                                        width: "100%",
                                                                        height: "100%",
                                                                        border: "none",
                                                                        objectFit: "cover"
                                                                    }}
                                                                    allow="autoplay"
                                                                ></iframe>

                                                            </Grid>
                                                        );
                                                    }
                                                    return null;
                                                })}
                                            </Grid>

                                        </div>
                                    </div>
                                </div>
                            )}



                            {/* Modal */}
                            {openMosaicoDisponibilidade && (
                                <div
                                    style={{
                                        position: "fixed",
                                        top: "0",
                                        left: "0",
                                        width: "100vw",
                                        height: "100vh",
                                        backgroundColor: "rgba(0, 0, 0, 0.5)", // Fundo escuro com opacidade
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        zIndex: "1100",
                                    }}
                                >
                                    <div
                                        style={{
                                            backgroundColor: darkMode ? "#1e1e1e" : "white",
                                            color: darkMode ? "#fff" : "inherit",
                                            width: "95%",
                                            height: "95%",
                                            borderRadius: "8px",
                                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)", // Sombra para destaque
                                            display: "flex",
                                            flexDirection: "column",
                                            padding: "10px",
                                            position: "relative",
                                        }}
                                    >
                                        {/* Botão de fechar */}
                                        <button
                                            onClick={(e) => closeMosaicoDisponibilidade()}
                                            style={{
                                                position: "absolute",
                                                top: "10px",
                                                right: "10px",
                                                backgroundColor: "#FF4500",
                                                color: "white",
                                                border: "none",
                                                borderRadius: "4px",
                                                padding: "8px",
                                                cursor: "pointer",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            Fechar
                                        </button>



                                        {/* Conteúdo do Modal */}
                                        <h6 style={{ marginTop: 0 }}>Mosaico via serviço de disponibilidade</h6>

                                        {/* Espaço reservado para a tabela */}
                                        <div
                                            style={{
                                                flex: 1,
                                                overflowY: "auto", // Adiciona rolagem se a tabela for grande
                                                border: darkMode ? "1px solid #444" : "1px solid #ddd",
                                                borderRadius: "4px",
                                                padding: "10px",
                                                backgroundColor: darkMode ? "#121212" : "transparent"
                                            }}
                                        >

                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="center"
                                                align="center"
                                                item xs={12}
                                                style={{ padding: 1 }}
                                            >
                                                {Array.isArray(instalacaoSelecionada?.equipamentos) && (
                                                    <CamerasComponent
                                                        flag={1}
                                                        cameras={instalacaoSelecionada.equipamentos
                                                            .filter(equipamento => equipamento && equipamento.tipo_equipamento_area_tecnica === 80 && equipamento.ip)}
                                                    />
                                                )}
                                            </Grid>

                                        </div>
                                    </div>
                                </div>
                            )}



        </>
    );
};

export default PainelInstalacaoDetalhes;
